/*
 * @Author: your name
 * @Date: 2020-09-14 10:30:10
 * @LastEditTime: 2020-10-16 15:46:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\pages\home\models\ContactUs.ts
 */
export class ContactUs {
  [key: string]: string
  addr: string
  contactPerson: string
  tel: string
  email: string
  qrcode: string
  constructor (addr: string, contactPerson: string, tel: string, email: string, qrcode: string) {
    this.addr = addr
    this.contactPerson = contactPerson
    this.tel = tel
    this.email = email
    this.qrcode = qrcode
  }
}
